import { createApplicationService } from "./base/applicationServiceBase";
import { CaseAPI as baseURL, API } from "api/axios.config";
import { useMemo } from "react";

const BRANCHES_BASE = "/Branches";

const fetchBranchesAPI = () => API.get(`${BRANCHES_BASE}`);

const addNewBranchAPI = (data) =>
  API.post(`${BRANCHES_BASE}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

const updateBranchAPI = (id, data) =>
  API.patch(`${BRANCHES_BASE}/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

const baseService = createApplicationService({
  name: "branches",
  apiFetchFn: fetchBranchesAPI,
  apiAddFn: addNewBranchAPI,
  apiUpdateFn: updateBranchAPI,
});

const branchReducer = baseService.reducer;
const getBranches = baseService.getData;
const addBranch = baseService.addData;
const updateBranch = baseService.updateData;
const useBranches = baseService.useData;

const getActiveBranches = async () => {
  const branches = await getBranches();
  return branches.filter((b) => b.active) || [];
};

const useActiveBranches = () => {
  const { data, loading } = useBranches();
  const activeBranches = useMemo(() => data.filter((b) => b.active), [data]);
  return { data: activeBranches, loading };
};

export {
  branchReducer,
  getBranches,
  addBranch,
  updateBranch,
  getActiveBranches,
  useBranches,
  useActiveBranches,
};
